import { OPEN_MODAL, CLOSE_MODAL } from '../actions/modalActions'

export default function modals(state = {}, action) {
  switch (action.type) {
    case OPEN_MODAL:
      return { ...state, [action.id]: true }
    case CLOSE_MODAL:
      return { ...state, [action.id]: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../src/reducers/modals.js